/* eslint no-unused-expressions: 0, prefer-destructuring: 0 */
import React, { Component } from 'react';
import { MAPBOX_GEOCODER_KEY } from '../constants';
import Button from "./Button.js";
import iconSearch from '../images/icon-search.svg';
import { isEs } from "../libs/lang";
import { fireTag } from '../libs/analytics.js';

let orgs = [];
let inputElem; //can't set this immediately as the Mapbox Geocoder injects this into the DOM
//const customPlaceholder = 'Enter City, State, ZIP, or Organization';
let customPlaceholder = '';

if (isEs()) {
	customPlaceholder = 'Ciudad, estado, código postal u organización';
}
else {
	customPlaceholder = 'Enter City, State, ZIP, or Organization'
}

function getmatchingOrgs(query) {
	const matchingOrgs = [];
	if (typeof orgs !== 'undefined') {
		for (let i = 0; i < orgs.length; i++) {
			const feature = orgs[i];
			// handle queries with different capitalization than the source data by calling toLowerCase()
			if (feature.properties.name
				.toLowerCase()
				.search(query.toLowerCase()) !== -1) {
				feature.id = feature.properties.id;
				feature.place_type = ['organization'];
				feature.relevance = 1;
				feature.text = feature.properties.name;
				feature.place_name = `${feature.properties.city}, ${feature.properties.state}`;
				feature.center = feature.geometry.coordinates;
				matchingOrgs.push(feature);
			}
		}
	}
	return matchingOrgs;
}

const enableInput = (gc) => {
	gc.getPlaceHolder !== customPlaceholder && gc.setPlaceholder(customPlaceholder);
	// gc.getPlaceHolder !== customPlaceholder && gc.(customPlaceholder);
	inputElem.disabled = false; //search input field ready for entries, so enable it.

	gc.setFilter(feature => (feature.relevance === 1 && feature.place_name !== 'United States of America'));

}



const initiateComboBox = () => {
  const inputBox = document.getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0];
  inputBox.role = "combobox";
  inputBox.ariaControls = "suggestion-list";
  inputBox.ariaAutoComplete = "list";
  inputBox.ariaLive = "polite";
  inputBox.ariaLabel = isEs() ? "Buscar region Encuentra una organización cerca de ti Editar marcador de posición en blanco Ingresa ciudad, estado, código postal u organización" : "Search Region Find an organization near you Edit blank placeholder Enter City, State, ZIP, or Organization Type in text";
  // inputElem.ariaReadOnly = "true";
  // inputBox.setAttribute('aria-activedescendant','suggestion-1');
  const suggestionsUL = document.querySelector('div.suggestions-wrapper > ul.suggestions');
  

  suggestionsUL.id = "suggestion-list";
  suggestionsUL.role = "listbox";

  inputBox.setAttribute('aria-owns','suggestion-list');
  //document.querySelectorAll('div.suggestions-wrapper > ul.suggestions li')
  const suggestionsLI = suggestionsUL.querySelectorAll('li');

  // Manages the updates of the combobox
  let value = suggestionsUL.style.getPropertyValue('display')

  const styleObserver = new MutationObserver((mutations) => {
    const currentValue = mutations[0].target.style.getPropertyValue('display');

    //maintainSuggestions();

    // console.log('currentValue ', currentValue);
    // console.log('value ', value);
    if (currentValue !== value) {
      // the variable has changed
      console.log('value has changed')
      // ariaExpanded
      if (currentValue == "block") {
        // Available to keyup or keydown
        document.getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0].addEventListener('keydown', (e) => {
          for (let x=0; x < document.querySelectorAll('div.suggestions-wrapper > ul.suggestions li').length; x++) {
              // console.log(document.querySelectorAll('div.suggestions-wrapper > ul.suggestions li')[x])
              if (document.querySelectorAll('div.suggestions-wrapper > ul.suggestions li')[x].classList.contains('active')) {
                document.getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0].setAttribute('aria-activedescendant',`suggestion-${x}`);
              }
              document.querySelectorAll('div.suggestions-wrapper > ul.suggestions li')[x].id = 'suggestion-' + x;
              document.querySelectorAll('div.suggestions-wrapper > ul.suggestions li')[x].role = 'option';
          }
        });

        // suggestionsUL.ariaExpanded = true;
		inputBox.ariaExpanded = true;
		inputBox.ariaLabel = isEs() ? "Buscar region Encuentra una organización cerca de ti Editar marcador de posición en blanco Ingresa ciudad, estado, código postal u organización Escribe el texto - Cuadro de lista abierto" : "Search Region Find an organization near you Edit blank placeholder Enter City, State, ZIP, or Organization Type in text - Listbox open";
      } else {
        // inputBox.removeEventListener('keydown', (e) => console.log(e));
        // suggestionsUL.ariaExpanded = false;
		inputBox.ariaExpanded = false;
		inputBox.ariaLabel = isEs() ? "Buscar region Encuentra una organización cerca de ti Editar marcador de posición en blanco Ingresa ciudad, estado, código postal u organización Escribe el texto" : "Search Region Find an organization near you Edit blank placeholder Enter City, State, ZIP, or Organization Type in text"
      }

      // find active element
      for (let i = 0; i < suggestionsLI.length; i++) {
        if (suggestionsLI[i].classList.contains('active')) {
          inputBox.setAttribute('aria-activedescendant',`suggestion-${i}`);
        }
      }

      value = currentValue;
    }
  });

  styleObserver.observe(suggestionsUL, {
    attributes: true,
    attributeFilter: ['style'],
  });
}

const trimUSA = (placeName) => {
	const termUSA = 'United States of America';
	const termUS = 'United States';

	const itemArray = placeName.split(', ');

	return ((itemArray[itemArray.length - 1] === termUSA || itemArray[itemArray.length - 1] === termUS) ? itemArray.pop() && itemArray.join(', ') : placeName)
}

const suggestionItemsHTML = (suggestionItem) => suggestionItem.place_type[0] === 'organization' ? `<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-title semibold">${suggestionItem.text}</div><div class="mapboxgl-ctrl-geocoder--suggestion-address">${trimUSA(suggestionItem.place_name)}</div></div>` : `<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-address semibold">${trimUSA(suggestionItem.place_name)}</div></div>`

const prepInputObj = (result, rawText) => {
	// result can be 1 of 3 types of items:
	// - keyword(s) - a set of characters entered by the user (if this, then there is no .place_name, so it is just the value of .result)
	// - region, place, country, postcode - a geographic location, which can be city, state, and country (if this, we need to trim the country)
	// - organization - an organization name (if this, then we just want the .text attribute which is just the org name)

	if (window.location.href.includes('/map/')) {
		fireTag("C1", rawText.toLowerCase());
	}
	else if (window.location.href.includes('/sustainability/')) {
		fireTag("C7", rawText.toLowerCase());
	}
	else {
		fireTag('C7', rawText.toLowerCase());
	}

	const inputObj = {
		center: [], coordinates: [], place_name: '', place_type: "keyword", text: rawText, raw: rawText, type: result.type, validLocation: result.validLocation,
	};


	if (Object.prototype.hasOwnProperty.call(result, 'place_type')) {
		// user entered a found valid geographic location
		inputObj.center = result.center;
		inputObj.coordinates = result.geometry.coordinates;
		inputObj.place_name = trimUSA(result.place_name);
		inputObj.place_type = result.place_type[0];
		if (result.place_type[0] !== 'organization') {
			inputObj.text = inputObj.place_name;
			inputObj.validLocation = true;
		}
	}

	return inputObj;
}

class Autocomplete extends Component {

	constructor(props) {

		super(props);

		// NOTE: MapboxGeocoder is defined in the https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.5.1/mapbox-gl-geocoder.min.js
		// Since autocomplete is used on every page/route, the MapboxGeocoder library JS (and its CSS) is called from the head tag of the index.html

		// instantiate our MapboxGeocoder object prior to using it.
		this.geoCoder = new window.MapboxGeocoder({
			accessToken: MAPBOX_GEOCODER_KEY, placeholder: "Loading Suggestions...", countries: 'us,pr', enableEventLogging: false, types: 'country,region,postcode,district,place', order: 'country,region,place,district,postcode,organization', localGeocoder: getmatchingOrgs, localLast: true, getItemValue(item) {
				return (typeof item.place_name !== 'undefined' ? item.place_type[0] === 'organization' ? item.text : trimUSA(item.place_name) : item)
			}, limit: 20, render(item) {
				return suggestionItemsHTML(item);
			}
		});

	}

	componentDidMount() {
		const {handleTextSearch, orgResults, currentSearch, checkForCityOrZip} = this.props;

		// add the Mapbox geoCoder to the autocomplete div after its in the DOM
		this.geoCoder.addTo('#autocomplete');

		inputElem = document.getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0];
		inputElem.id = 'search-input';
		inputElem.disabled = true; // disable input field initially, need to load in our org data first
		inputElem.type = "text";

		inputElem.setAttribute("aria-label", inputElem.value.length == 0 ? "Search Region Find an organization near you Edit blank placeholder Enter City, State, ZIP, or Organization Type in text" : "Search Region Find an organization near you Edit Type in text")
		inputElem.setAttribute("data-gtm-form-interact-field-id", "0")

		/////////////////////////////////////////////////////////////////////
		// Mapbox GeoCoder Event - occurs after suggestions are obtained
		// from Mapbox. We don't use this for our purposes.
		/////////////////////////////////////////////////////////////////////
		this.geoCoder.on('results', results => {
		});

		/////////////////////////////////////////////////////////////////////
		// Mapbox GeoCoder Event - occurs after suggestion selection or
		// user hits ENTER key after typing some characters
		/////////////////////////////////////////////////////////////////////
		this.geoCoder.on('result', async selectedItem => {
			const textObj = {};
			let geoResponseObj = {};
			
			console.log('selectedItem ', selectedItem);
			
			if (Object.prototype.hasOwnProperty.call(selectedItem.result, 'id')) {
				// user selected a suggested item from the list
				textObj.text = selectedItem.result.text;
				geoResponseObj = selectedItem.result;
			}
			else {
				// user just hit ENTER key after typing some characters
				console.log('user just hit ENTER key after typing some characters')
				textObj.text = selectedItem.result;
				textObj.fromURL = false;
				return;
				// geoResponseObj = await checkForCityOrZip(textObj);
			}

			console.log('geoResponseObj ', geoResponseObj);
			const preppedInput = prepInputObj(geoResponseObj, textObj.text);
			// !preppedInput.hasOwnProperty('raw') && (preppedInput.raw = textObj.text);

			console.log('preppedInput ', preppedInput);
			document.getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0].value = preppedInput.place_name;
			// we pass the selected item object
			handleTextSearch(preppedInput);
    });


		if (typeof orgResults !== 'undefined') {
			enableInput(this.geoCoder); // org data loaded, enable input field
		}

		if (inputElem.value !== currentSearch && typeof currentSearch !== 'undefined') {
			// otherwise set the input if not already set
			if (currentSearch.indexOf('invalid zip code') > -1) {
				// if invalid zip then only show zip code numerals in search field
				// really only needed for invalid zip searches from home or org detail page
				inputElem.value = currentSearch.substring(0, 5);
			}
			else {
				inputElem.value = currentSearch;
			}
		}
	}

	componentDidUpdate() {

		const {orgResults, clearAutocomplete} = this.props;

		orgs = orgResults;

		inputElem = document.getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0];
		inputElem.setAttribute("aria-label", inputElem.value.length == 0 ? "Search Region Find an organization near you Edit blank placeholder Enter City, State, ZIP, or Organization Type in text" : "Search Region Find an organization near you Edit Type in text")
		const wait = () => { // if the data was not loaded when component mounted, we wait and then enable it when data is loaded.

      if (typeof orgResults === 'undefined') {
          setTimeout(wait, 500);
      } else {
        inputElem.disabled && enableInput(this.geoCoder);
        initiateComboBox();
      }
    };

		if (clearAutocomplete) {
			this.geoCoder.clear();
		}

		wait();
	}

	render() {

		return (<>
				<div id="autocomplete" className="geocoder"/>
				<Button
					handleClick={async () => {
						if (inputElem.value === '') {
							document.querySelector('.map-container a').click();
						}
						else {
            this.props.handleTextSearch(
              prepInputObj(
                await this.props.checkForCityOrZip({
                  fromURL: false,
                  text:inputElem.value
                }),
                inputElem.value
              )
            )
						}
					}}
					buttonStyles="icon search-button"
					alttext={isEs() ? 'Inicia la búsqueda' : 'Begin Search'}
					type="submit"
					buttonID="search-btn"
				>
					<img src={iconSearch} className="icon-search results" alt={isEs() ? 'Ícono de búsqueda' : 'search icon'}/>
				</Button>
			</>);

	}
}

export default Autocomplete;
